export function getComponentsLimits(dashboard, patreonMember, user) {
  if (user.additional_roles && user.additional_roles.length > 0) {
    return Infinity;
  }

  const isPatreon =
    patreonMember &&
    patreonMember != null &&
    patreonMember.patron_status == "active_patron";

  const tier =
    isPatreon && patreonMember.tier_title ? patreonMember.tier_title : null;

  if (tier === "Angel") {
    return Infinity;
  }

  if (tier === "Fan") {
    return 20;
  }

  return 5;
}
